import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Flex } from "@faire/web--source/slate/Layout";
import React from "react";
import styled, { css, keyframes } from "styled-components";
export var NotificationBubbleDot = function(param) {
    var hasHighPriority = param.hasHighPriority, shouldAnimate = param.shouldAnimate, dataTestId = param.dataTestId, delayAnimationTime = param.delayAnimationTime;
    return /*#__PURE__*/ _jsx(Dot, {
        "data-test-id": dataTestId,
        $shouldAnimate: shouldAnimate,
        $hasHighPriority: hasHighPriority,
        style: {
            animationDelay: delayAnimationTime ? "".concat(delayAnimationTime, "ms") : undefined
        }
    });
};
var bounce = keyframes([
    "0%,100%{width:0px;height:0px;opacity:0;}40%{width:12px;height:12px;opacity:1;}45%{width:11px;height:11px;opacity:1;}50%,100%{width:12px;height:12px;opacity:1;}"
]);
var Dot = styled(Flex).withConfig({
    componentId: "sc-4d08d6cb-0"
})([
    "border-radius:50%;background:",
    ";border:2px solid ",
    ";",
    " animation-fill-mode:both;"
], function(param) {
    var $hasHighPriority = param.$hasHighPriority;
    return $hasHighPriority ? css([
        "#e65126"
    ]) : css([
        "",
        ""
    ], Core.surface.default);
}, Core.text.inverse, function(param) {
    var $shouldAnimate = param.$shouldAnimate;
    return $shouldAnimate ? css([
        "animation:",
        " 2s ease-in-out;"
    ], bounce) : css([
        "width:12px;height:12px;opacity:1;"
    ]);
});
